import React, { useContext, useState } from 'react';
import { Button, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../store';
import TransferTable from './TransferTable';
import DashboardHeader from '../../../common/DasnboardHeader/DashboardHeader';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import { styleBg } from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TransferCatalogueMain(props) {
  const navigate = useNavigate();
  const { role } = useContext(StateContext);
  const [value, setValue] = React.useState(0);
  const [meta, setMeta] = useState({ total: 0 });

  const handleTransfer = () => {
    navigate('/management/transfers/create');
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleDescription = () => {
    if (value === 0) {
      return 'Total Pending'
    } else if (value === 1) {
      return 'Total Accepted'
    } else
      return 'Total Rejected'
  }

  return (
    <PageWrapper>
      {role?.id !== 2 ?
        <div>
          <DashboardHeader title={"Transfer"} total={meta?.total} IconName={AssuredWorkloadRoundedIcon} iconColor={'#ff9653'}
            desc={handleDescription()} />
        </div> :
        <Box sx={{ mb: 2, backgroundColor: '#ffffff', padding: 2 }}>
          <Grid container>
            <Grid item sm={10.5}>
              <DashboardHeader title="Transfer" total={meta?.total} IconName={AssuredWorkloadRoundedIcon} iconColor={'#ff9653'}
                desc={handleDescription()} />
            </Grid>
            <Grid item sm={1.5}>
              <Button onClick={() => handleTransfer()} variant={'contained'}>+ Transfer</Button>
            </Grid>
          </Grid>
        </Box>
      }
      <Box sx={{ mt: 2 }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="PENDING TRANSFER LIST" {...a11yProps(0)} sx={{ width: 250, ...styleBg(0, value) }} />
          <Tab label="ACCEPTED TRANSFER LIST" {...a11yProps(1)} sx={{ width: 250, ...styleBg(1, value) }} />
          <Tab label="REJECTED TRANSFER LIST" {...a11yProps(2)} sx={{ width: 250, ...styleBg(2, value) }} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <TransferTable status={'requested'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TransferTable status={'approved'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <TransferTable status={'rejected'} meta={meta} setMeta={setMeta} />
      </CustomTabPanel>
    </PageWrapper>
  );
}